import {useFastlyQuery} from "@repo/data-gql";
import {RequestInfo} from "@repo/shared-core";

import {UNTRANSLATED_CONTENT_QUERY} from "../queries.ts";

type ContentExistsInEnglishResult =
    | {
          status: "error";
      }
    | {
          status: "loading";
      }
    | {
          status: "success";
          existsInEnglish: boolean;
      };

type Options = {
    skip?: boolean;
};

// This checks if the content exists in English, regardless of the user's
// selected locale. It is intended to be used to display a message offering
// a link to the English version of the content if it does not exist in the
// selected locale. This is helpful because a user who has set their locale
// to something other than English can be redirected from a valid link on
// www to an invalid link on their language's subdomain.
const useContentExistsInEnglish = (
    contentPath: string,
    options?: Options,
): ContentExistsInEnglishResult => {
    const untranslatedQueryResult = useFastlyQuery(UNTRANSLATED_CONTENT_QUERY, {
        skip: options?.skip ?? false,
        variables: {
            path: contentPath,
            countryCode: RequestInfo.remoteCountry,
        },
        targetLocale: "en",
    });

    switch (untranslatedQueryResult.status) {
        case "no-data":
        case "loading":
            return {status: "loading"};
        case "aborted":
        case "error":
            return {status: "error"};
        default:
            return {
                status: "success",
                existsInEnglish:
                    !!untranslatedQueryResult.data?.contentRoute?.resolvedPath,
            };
    }
};

export default useContentExistsInEnglish;
